import { render, staticRenderFns } from "./loginOnebutton.vue?vue&type=template&id=4153a151&scoped=true&"
import script from "./loginOnebutton.vue?vue&type=script&lang=js&"
export * from "./loginOnebutton.vue?vue&type=script&lang=js&"
import style0 from "./loginOnebutton.vue?vue&type=style&index=0&id=4153a151&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4153a151",
  null
  
)

export default component.exports